export const reveals = [
  {
    id: 1,
    title: "知名带货主播小杨哥直播翻车，产品质量遭全网质疑",
    category: "网红塌房",
    articleSlug: "xiaoyangge-livestream-scandal",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20a%20livestreaming%20studio%20with%20red%20warning%20light%2C%20broken%20products%20on%20table%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20mysterious%20atmosphere%2C%20warm%20amber%20and%20crimson%20tones%2C%20editorial%20photography%20style%20with%20soft%20shadows%20and%20high%20contrast%2C%20dark%20studio%20background%20with%20subtle%20red%20glow%2C%20tense%20and%20dramatic%20mood&width=800&height=960&seq=reveal-01&orientation=portrait",
    time: "2小时前",
    hot: 98532,
  },
  {
    id: 2,
    title: "某顶流男星深夜密会神秘女子，酒店监控画面流出",
    category: "明星爆料",
    articleSlug: "top-star-hotel-scandal",
    imageUrl: "https://readdy.ai/api/search-image?query=Blurry%20night%20scene%20outside%20luxury%20hotel%20entrance%2C%20silhouettes%20of%20two%20people%2C%20paparazzi%20style%20photography%2C%20warm%20street%20lights%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20dark%20background%20with%20neon%20signs%2C%20grainy%20film%20texture%2C%20voyeuristic%20angle%2C%20dramatic%20shadows%2C%20warm%20amber%20and%20deep%20shadow%20tones&width=800&height=960&seq=reveal-02&orientation=portrait",
    time: "5小时前",
    hot: 125470,
  },
  {
    id: 3,
    title: "某知名女团成员疑似恋情曝光，粉丝后援会集体脱粉",
    category: "明星爆料",
    articleSlug: "girl-group-dating-rumor",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20stage%20spotlight%20shining%20on%20empty%20microphone%20stand%2C%20scattered%20fan%20letters%20on%20ground%2C%20blurry%20crowd%20in%20background%2C%20melancholic%20atmosphere%2C%20warm%20golden%20spotlight%20against%20dark%20stage%2C%20emotional%20mood%2C%20concert%20aftermath%20scene%2C%20soft%20cinematic%20lighting%2C%20editorial%20photography&width=800&height=960&seq=reveal-03&orientation=portrait",
    time: "8小时前",
    hot: 87651,
  },
  {
    id: 4,
    title: "百万粉美食博主被曝后厨卫生堪忧，顾客吃出异物",
    category: "网红塌房",
    articleSlug: "food-blogger-hygiene-scandal",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20messy%20restaurant%20kitchen%20scene%2C%20dirty%20countertop%20with%20scattered%20food%20waste%2C%20dramatic%20cinematic%20lighting%2C%20warm%20overhead%20light%20casting%20long%20shadows%2C%20tense%20investigative%20journalism%20style%2C%20dark%20background%2C%20subtle%20red%20warning%20signs%2C%20high%20contrast%20composition%2C%20gritty%20atmosphere&width=800&height=960&seq=reveal-04&orientation=portrait",
    time: "12小时前",
    hot: 54320,
  },
  {
    id: 5,
    title: "知名导演被多名女演员实名举报潜规则，聊天记录曝光",
    category: "匿名黑料",
    articleSlug: "director-metoo-allegations",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20interrogation%20room%20style%20scene%2C%20documents%20and%20phone%20on%20desk%20with%20blurry%20chat%20screens%2C%20dramatic%20lighting%20from%20single%20source%2C%20mysterious%20atmosphere%2C%20anonymous%20whistleblower%20vibe%2C%20warm%20desk%20lamp%20glow%20against%20dark%20room%2C%20cinematic%20composition%2C%20investigative%20journalism%20aesthetic%2C%20high%20contrast%20shadows&width=800&height=960&seq=reveal-05&orientation=portrait",
    time: "1天前",
    hot: 156890,
  },
  {
    id: 6,
    title: "某选秀冠军涉税务问题被调查，金额高达数千万",
    category: "明星爆料",
    articleSlug: "talent-show-winner-tax-investigation",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20office%20scene%20with%20stacks%20of%20documents%20and%20financial%20reports%2C%20red%20stamp%20marks%20on%20paper%2C%20dramatic%20desk%20lamp%20lighting%2C%20legal%20investigation%20atmosphere%2C%20warm%20amber%20light%20on%20papers%2C%20dark%20background%2C%20cinematic%20composition%2C%20serious%20and%20tense%20mood%2C%20high%20contrast%20editorial%20style&width=800&height=960&seq=reveal-06&orientation=portrait",
    time: "1天前",
    hot: 78930,
  },
  {
    id: 7,
    title: "知名电竞主播开挂实锤，直播中不小心露出外挂界面",
    category: "网红塌房",
    categorySlug: "influencer-collapse",
    imageUrl: "https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20multiple%20screens%20showing%20warning%20red%20alert%20popups%2C%20dramatic%20RGB%20lighting%2C%20dark%20room%20atmosphere%2C%20hacker%20vibe%2C%20cinematic%20composition%2C%20warm%20red%20glow%20on%20gaming%20chair%2C%20tense%20and%20dramatic%20mood%2C%20esports%20investigation%20aesthetic&width=800&height=960&seq=reveal-07&orientation=portrait",
    time: "2天前",
    hot: 67450,
  },
  {
    id: 8,
    title: "某知名夫妻档网红被爆早已离婚，合体视频全是演戏",
    category: "网红塌房",
    categorySlug: "influencer-collapse",
    imageUrl: "https://readdy.ai/api/search-image?query=Broken%20heart%20shaped%20neon%20sign%20on%20dark%20wall%2C%20scattered%20photographs%20on%20table%2C%20melancholic%20atmosphere%2C%20warm%20amber%20neon%20glow%2C%20cinematic%20composition%2C%20relationship%20drama%20theme%2C%20dark%20moody%20background%2C%20soft%20bokeh%20lights%2C%20emotional%20and%20dramatic%20editorial%20style&width=800&height=960&seq=reveal-08&orientation=portrait",
    time: "2天前",
    hot: 102340,
  },
];

export const dailyContests = [
  {
    id: 1,
    rank: 1,
    title: "2026年度最大塌房事件评选",
    desc: "多位顶流明星接连翻车，谁的塌房最让你意外？投票进行中",
    hot: "158万",
    categorySlug: "daily-contest",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20stage%20collapse%20metaphor%20scene%2C%20falling%20spotlights%20in%20dark%20theater%2C%20cinematic%20lighting%2C%20warm%20golden%20and%20red%20tones%2C%20powerful%20composition%2C%20abstract%20dramatic%20atmosphere%2C%20dark%20background%20with%20floating%20debris%2C%20editorial%20photography%20style&width=600&height=400&seq=daily-01&orientation=landscape",
  },
  {
    id: 2,
    rank: 2,
    title: "网红翻车合集大比拼",
    desc: "从带货翻车到人品崩塌，盘点今年最离谱的网红塌房现场",
    hot: "126万",
    categorySlug: "influencer-collapse",
    imageUrl: "https://readdy.ai/api/search-image?query=Collection%20of%20shattered%20phone%20screens%20on%20dark%20surface%2C%20each%20showing%20social%20media%20failure%20messages%2C%20dramatic%20lighting%2C%20warm%20amber%20and%20crimson%20tone%2C%20cinematic%20composition%2C%20dark%20moody%20background%2C%20digital%20drama%20concept&width=600&height=400&seq=daily-02&orientation=landscape",
  },
  {
    id: 3,
    rank: 3,
    title: "娱乐圈年度十大未解之谜",
    desc: "那些悬而未决的娱乐圈悬案，你最想知道哪个真相？",
    hot: "98万",
    categorySlug: "celebrity-reveal",
    imageUrl: "https://readdy.ai/api/search-image?query=Mysterious%20detective%20board%20with%20red%20strings%20connecting%20photos%20in%20dark%20room%2C%20dramatic%20lighting%2C%20investigation%20theme%2C%20warm%20desk%20lamp%20glow%2C%20cinematic%20composition%2C%20dark%20background%2C%20conspiracy%20theory%20aesthetic%2C%20editorial%20photography&width=600&height=400&seq=daily-03&orientation=landscape",
  },
  {
    id: 4,
    rank: 4,
    title: "明星恋情真假鉴定大赛",
    desc: "各路明星CP到底是真爱还是炒作？吃瓜群众一起来鉴定",
    hot: "87万",
    categorySlug: "celebrity-reveal",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20shadow%20silhouettes%20separated%20by%20question%20mark%20shaped%20neon%20light%2C%20dark%20romantic%20atmosphere%2C%20warm%20pink%20and%20red%20neon%20glow%2C%20cinematic%20composition%2C%20mysterious%20couple%20theme%2C%20dark%20background%2C%20soft%20ambient%20lighting&width=600&height=400&seq=daily-04&orientation=landscape",
  },
  {
    id: 5,
    rank: 5,
    title: "年度最佳吃瓜表情包大赛",
    desc: "今年最出圈的吃瓜表情包都在这里，快来投票选出年度最佳",
    hot: "76万",
    categorySlug: "daily-contest",
    imageUrl: "https://readdy.ai/api/search-image?query=Collage%20of%20watermelon%20slices%20in%20dramatic%20lighting%20on%20dark%20background%2C%20one%20slice%20in%20spotlight%2C%20playful%20yet%20cinematic%20composition%2C%20warm%20red%20and%20green%20tones%2C%20dark%20moody%20background%2C%20editorial%20food%20photography%20style%20with%20dramatic%20shadows&width=600&height=400&seq=daily-05&orientation=landscape",
  },
  {
    id: 6,
    rank: 6,
    title: "配音演员塌房大盘点",
    desc: "声优圈也逃不过塌房魔咒，盘点那些让人大跌眼镜的配音圈大瓜",
    hot: "65万",
    categorySlug: "influencer-collapse",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20recording%20studio%20with%20microphone%20in%20spotlight%2C%20broken%20headphones%20on%20floor%2C%20dramatic%20cinematic%20lighting%2C%20warm%20golden%20spotlight%20against%20dark%20background%2C%20sound%20wave%20visualization%20in%20red%2C%20moody%20atmosphere&width=600&height=400&seq=daily-06&orientation=landscape",
  },
];

export const comments = [
  {
    id: 1,
    nickname: "吃瓜不嫌事大",
    username: "@chigua_001",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20orange%20gradient%2C%20clean%20geometric%20design%2C%20soft%20lighting%2C%20modern%20aesthetic%2C%20simple%20background&width=100&height=100&seq=avatar-01&orientation=squarish",
    content: "这个瓜我吃了三天了还没消化完，剧情反转比我追的电视剧还精彩。只能说贵圈真乱，我等凡人看看就好。",
    likes: 2356,
  },
  {
    id: 2,
    nickname: "理性吃瓜人",
    username: "@lixing_2024",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20coral%20gradient%2C%20clean%20geometric%20design%2C%20soft%20lighting%2C%20modern%20aesthetic%2C%20simple%20background&width=100&height=100&seq=avatar-02&orientation=squarish",
    content: "我还是那句话，没有实锤别乱传。现在网上反转太多，让子弹飞一会儿再评价也不迟。",
    likes: 1823,
  },
  {
    id: 3,
    nickname: "深夜瓜田守望者",
    username: "@nightwatcher",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20amber%20gradient%2C%20clean%20geometric%20design%2C%20soft%20lighting%2C%20modern%20aesthetic%2C%20simple%20background&width=100&height=100&seq=avatar-03&orientation=squarish",
    content: "凌晨三点还在刷瓜的举爪！这波料太猛了，明天上班估计要顶着黑眼圈了，但值了！",
    likes: 4102,
  },
  {
    id: 4,
    nickname: "娱乐圈观察员",
    username: "@observer_ylq",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20red%20gradient%2C%20clean%20geometric%20design%2C%20soft%20lighting%2C%20modern%20aesthetic%2C%20simple%20background&width=100&height=100&seq=avatar-04&orientation=squarish",
    content: "从业十年，这次的事情绝对不是表面上看起来那么简单。背后牵扯的利益关系比大家想象的复杂得多。",
    likes: 5678,
  },
  {
    id: 5,
    nickname: "瓜田里的猹",
    username: "@watermelon_fan",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20peach%20gradient%2C%20clean%20geometric%20design%2C%20soft%20lighting%2C%20modern%20aesthetic%2C%20simple%20background&width=100&height=100&seq=avatar-05&orientation=squarish",
    content: "我的表情包已经准备好了，就等明天当事人发声明了。这波操作我已经预判了他们的预判！",
    likes: 1987,
  },
  {
    id: 6,
    nickname: "真相只有一个",
    username: "@truth_seeker",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20gold%20gradient%2C%20clean%20geometric%20design%2C%20soft%20lighting%2C%20modern%20aesthetic%2C%20simple%20background&width=100&height=100&seq=avatar-06&orientation=squarish",
    content: "给大家梳理一下时间线：首先是上个月的综艺录制出了状况，然后是这个月的品牌解约，再到今天的爆料，一切都有迹可循。",
    likes: 3245,
  },
];